export default __webpack_public_path__ + "static/media/card1.49c1956c.jpeg";